import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Container } from "reactstrap";
import { CSSTransition } from 'react-transition-group';

import useIsInViewport from "ui/hooks/inViewport";

import { ThemeContext } from "../../context/ThemeContext";

import Abstract from "../../Abstracts/Abstract3";
import employer1 from "assets/img/homepage/employer/employer_detail_1.jpg";
import employer2 from "assets/img/homepage/employer/employer_detail_2.jpg";
import employer3 from "assets/img/homepage/employer/employer_detail_3.jpg";

const EmployerDetails = (props) => {
    const context = useContext( ThemeContext );
    const [inView1, employerImg1] = useIsInViewport();
    const [inView2, employerImg2] = useIsInViewport();
    const [inView3, employerImg3] = useIsInViewport();



    return(
        <section id="mainDetails" className={"upward_more_details "+ (context ? "upward_more_details_"+context : "") }>
            <Container>
                <div className="abstract_container abstract_switched" ><Abstract /></div>
                <div className="language_wrapper">
                    <Row className="d-flex justify-content-center align-items-center">
                        <Col xs="12" lg={{"size":5}} className="mb-3 mb-lg-0" >
                            <CSSTransition in={inView1} timeout={200} classNames="more_details_img"><img ref={employerImg1} className="img-fluid rounded more_details_img" src={employer1} alt="We Deliver Performance" /></CSSTransition>
                        </Col>
                        <Col xs="12" lg={{"size":5,"offset":1}} >
                            <h3>Over 1.5 million<br/>applications every month</h3>
                            <p>Yes, every month.</p><p>We deliver across multiple <a href="/enterprise#serveIndustries">industries</a> from small restaurant owners to large Fortune 1000 companies.</p><p>Upward and Jobcase can deliver for you, too.</p>
                        </Col>
                    </Row>
                </div>
                <div className="language_wrapper">
                    <Row className="d-flex justify-content-center align-items-center">
                        <Col xs="12" lg={{"size":5,"offset":1}} className="order-lg-12 mb-3 mb-lg-0" >
                            <CSSTransition in={inView2} timeout={200} classNames="more_details_img"><img ref={employerImg2} className="img-fluid rounded more_details_img" src={employer2} alt="HR Technoloy Solution" /></CSSTransition>
                        </Col>
                        <Col xs="12" lg={{"size":5}} >
                            <h3>We work on your terms</h3>
                            <p>For as little as <b><u>$50 per posting</u></b>, your job can appear on hundreds of job sites including Upward and Jobcase.</p>
                            <p>If you want to take the wheel, you can do that too.</p>
                            <p><Link to="?pricing=y" className="text-dark-orange"><b>Learn about pricing</b></Link></p>
                        </Col>
                    </Row>
                </div>
                <div className="language_wrapper">
                    <Row className="d-flex justify-content-center align-items-center">
                        <Col xs="12" lg={{"size":5}} className="mb-3 mb-lg-0" >
                            <CSSTransition in={inView3} timeout={200} classNames="more_details_img"><img ref={employerImg3} className="img-fluid rounded more_details_img" src={employer3} alt="Customized Solutions" /></CSSTransition>
                        </Col>
                        <Col xs="12" lg={{"size":5,"offset":1}} >
                            <h3>Compatible with your ATS or HR System</h3>
                            <p>Have your own ATS or HR system already?</p><p>No problem. We can fit right into your life, and work with hundreds of your favorite HR products.</p>
                        </Col>
                    </Row>
                </div>
            </Container>
        </section>
    )

}

export default EmployerDetails;